import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DatetimeService {
  constructor() {}

  /**
   * formats date to yyyy-MM-dd HH:mm:ss
   */
  dateToyyyyMMddHHmmss(date: Date) {
    return formatDate(date, 'yyyy-MM-dd HH:mm:ss', 'en-US');
  }

  /**
   * formats date to yyyy-MM-dd
   * */
  dateToyyyyMMdd(date: Date) {
    return formatDate(date, 'yyyy-MM-dd', 'en-US');
  }
}
